import {
  PredictionTypeEnum,
  PropertySubTypeEnum,
  PropertyTypeEnum,
} from '@engelvoelkersamericas/api';
import { useTranslations } from 'next-intl';

export const tPropertyType = (propertyType: PropertyTypeEnum) => {
  const t = useTranslations();
  switch (propertyType) {
    case PropertyTypeEnum.BusinessOpportunity:
      return t('PropertyTypes.businessOpportunity');
    case PropertyTypeEnum.CommercialLease:
      return t('PropertyTypes.commercialLease');
    case PropertyTypeEnum.CommercialSale:
      return t('PropertyTypes.commercialSale');
    case PropertyTypeEnum.Farm:
      return t('PropertyTypes.farm');
    case PropertyTypeEnum.Land:
      return t('PropertyTypes.land');
    case PropertyTypeEnum.ManufacturedInPark:
      return t('PropertyTypes.manufacturedInPark');
    case PropertyTypeEnum.Residential:
      return t('PropertyTypes.residential');
    case PropertyTypeEnum.ResidentialIncome:
      return t('PropertyTypes.residentialIncome');
    case PropertyTypeEnum.ResidentialLease:
      return t('PropertyTypes.residentialLease');
  }
};

export const tPropertySubType = (propertySubType: PropertySubTypeEnum): string => {
  const t = useTranslations();
  switch (propertySubType) {
    case PropertySubTypeEnum.Agriculture:
      return t('PropertySubTypes.agriculture');
    case PropertySubTypeEnum.Apartment:
      return t('PropertySubTypes.apartment');
    case PropertySubTypeEnum.BoatSlip:
      return t('PropertySubTypes.boatSlip');
    case PropertySubTypeEnum.Business:
      return t('PropertySubTypes.business');
    case PropertySubTypeEnum.Cabin:
      return t('PropertySubTypes.cabin');
    case PropertySubTypeEnum.Condominium:
      return t('PropertySubTypes.condominium');
    case PropertySubTypeEnum.DeededParking:
      return t('PropertySubTypes.deededParking');
    case PropertySubTypeEnum.Duplex:
      return t('PropertySubTypes.duplex');
    case PropertySubTypeEnum.Farm:
      return t('PropertySubTypes.farm');
    case PropertySubTypeEnum.HotelMotel:
      return t('PropertySubTypes.hotelMotel');
    case PropertySubTypeEnum.Industrial:
      return t('PropertySubTypes.industrial');
    case PropertySubTypeEnum.ManufacturedHome:
      return t('PropertySubTypes.manufacturedHome');
    case PropertySubTypeEnum.ManufacturedOnLand:
      return t('PropertySubTypes.manufacturedOnLand');
    case PropertySubTypeEnum.MixedUse:
      return t('PropertySubTypes.mixedUse');
    case PropertySubTypeEnum.MobileHome:
      return t('PropertySubTypes.mobileHome');
    case PropertySubTypeEnum.MultiFamily:
      return t('PropertySubTypes.multiFamily');
    case PropertySubTypeEnum.Office:
      return t('PropertySubTypes.office');
    case PropertySubTypeEnum.OwnYourOwn:
      return t('PropertySubTypes.ownYourOwn');
    case PropertySubTypeEnum.Quadruplex:
      return t('PropertySubTypes.quadruplex');
    case PropertySubTypeEnum.Ranch:
      return t('PropertySubTypes.ranch');
    case PropertySubTypeEnum.Retail:
      return t('PropertySubTypes.retail');
    case PropertySubTypeEnum.SingleFamilyResidence:
      return t('PropertySubTypes.singleFamilyResidence');
    case PropertySubTypeEnum.StockCooperative:
      return t('PropertySubTypes.stockCooperative');
    case PropertySubTypeEnum.Timeshare:
      return t('PropertySubTypes.timeshare');
    case PropertySubTypeEnum.Townhouse:
      return t('PropertySubTypes.townhouse');
    case PropertySubTypeEnum.Triplex:
      return t('PropertySubTypes.triplex');
    case PropertySubTypeEnum.UnimprovedLand:
      return t('PropertySubTypes.unimprovedLand');
    case PropertySubTypeEnum.Warehouse:
      return t('PropertySubTypes.warehouse');
  }
};

export const tPredictionType = (type: PredictionTypeEnum): string => {
  const t = useTranslations();
  switch (type) {
    case PredictionTypeEnum.Country:
      return t('PredictionType.countries');
    case PredictionTypeEnum.State:
      return t('PredictionType.states');
    case PredictionTypeEnum.City:
      return t('PredictionType.cities');
    case PredictionTypeEnum.CityRegion:
      return t('PredictionType.regions');
    case PredictionTypeEnum.Neighborhood:
      return t('PredictionType.neighborhoods');
    case PredictionTypeEnum.PostalCode:
      return t('PredictionType.postalCodes');
    case PredictionTypeEnum.Address:
      return t('PredictionType.listings');
  }
};
